export class User {
    constructor(public _id: string, public email: string, public fullname: string, public type: number) {
    }
}
